module.exports = __webpack_public_path__ + "static/media/card_icon_10.8dbf42fd.png";